<div class="form-group" id="searchbar">
    <input #inputSearch type="search" (focusout)="search($event)" (keyup.enter)="search($event)"
        [(ngModel)]="searchText" class="autocomplete" placeholder='Cerca contenuti in "{{textPlaceholder| translate}}"'>
    <span class="autocomplete-icon" aria-hidden="true">
        <svg-icon-sprite src="../../../assets/sprite.svg#it-search" class="icon-search" (click)="search($event)">
        </svg-icon-sprite>
    </span>
    <p *ngIf="errorMessage" class="error">{{errorMessage}}</p>
</div>